import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon, TruckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-200 py-12 border-t border-slate-800" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-44">
          {/* Company Info */}
          <div data-id="element-45">
            <div className="flex items-center space-x-2 mb-4" data-id="element-46">
              <TruckIcon className="h-6 w-6 text-primary" data-id="element-47" />
              <span className="font-bold text-xl text-white" data-id="element-48">
                Universal Global
              </span>
            </div>
            <p className="text-slate-400 text-sm mb-6 leading-relaxed" data-id="element-49">
              UK's leading emergency courier providers. Hire professional
              drivers on demand and book reliable item delivery services
              nationwide.
            </p>
            <div className="flex space-x-4" data-id="element-50">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-51">
                <FacebookIcon className="h-5 w-5" data-id="element-52" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" aria-label="Twitter" data-id="element-53">
                <TwitterIcon className="h-5 w-5" data-id="element-54" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-55">
                <LinkedinIcon className="h-5 w-5" data-id="element-56" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-57">
                <InstagramIcon className="h-5 w-5" data-id="element-58" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-59">
            <h3 className="font-semibold text-white mb-4" data-id="element-60">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-61">
              <li data-id="element-62">
                <Link to="/" className="text-slate-400 hover:text-primary transition-colors" data-id="element-63">
                  Home
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/about" className="text-slate-400 hover:text-primary transition-colors" data-id="element-65">
                  About Us
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-67">
                  Services
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/contact" className="text-slate-400 hover:text-primary transition-colors" data-id="element-69">
                  Contact
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/quote" className="text-slate-400 hover:text-primary transition-colors" data-id="element-71">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-72">
            <h3 className="font-semibold text-white mb-4" data-id="element-73">Services</h3>
            <ul className="space-y-2 text-sm" data-id="element-74">
              <li data-id="element-75">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-76">
                  Emergency Courier Drivers
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-78">
                  Driver Hire
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-80">
                  Item & Parcel Delivery
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-82">
                  Office Relocation
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors" data-id="element-84">
                  House Relocation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-85">
            <h3 className="font-semibold text-white mb-4" data-id="element-86">Contact</h3>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-87">
              <li data-id="element-88">
                <span className="block text-white mb-1" data-id="element-89">Phone:</span>
                07405 611 227
              </li>
              <li data-id="element-90">
                <span className="block text-white mb-1" data-id="element-91">Email:</span>
                john@universalgloballogistics.co.uk
              </li>
              <li data-id="element-92">
                <span className="block text-white mb-1" data-id="element-93">Hours:</span>
                24/7 Emergency Support
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-center text-sm text-slate-500" data-id="element-94">
          <p data-id="element-95">
            © {new Date().getFullYear()} Universal Global Logistics –
            Nationwide Delivery & Logistics Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}